export default __webpack_public_path__ + "static/media/7B2_E-6102.a71ca005.png";